module.exports = __webpack_public_path__ + "static/media/ic_close.4cafe58d.svg";